export default __webpack_public_path__ + "static/doccam_b.cbf0dc1acba48acab721558e673bf03b.svg";